<!-- template for the modal component -->
<template type="x/template">
    <transition name="modal" id="googleAd-dialog">
        <div class="modal-mask" v-show="show">
            <div class="modal-container" @click.stop>
                <div class="modal-header">
                    <h3>{{ modalData.id ? 'Hirdetés módosítása' : 'Új hirdetés' }}</h3>
                </div>
                <div class="modal-body">
                    <div class="form-group row">
                        <div class="col-lg-12">
                            <div class="row mb-2">
                                <div class="col-lg-12">
                                    <label class="control-label">Név</label>
                                    <input type="text" class="form-control" v-model="modalData.name"
                                           :class="{ 'field-error' : this.$v.modalData.name.$error }"/>
                                </div>
                            </div>


                            <div class="row">
                                <div class="col-lg-12">
                                    <nav>
                                        <div class="nav nav-tabs pt-3" id="nav-tab" role="tablist">
                                            <a class="nav-item nav-link" :class="{'active': desktop_active}" id="nav-home-tab"
                                               data-toggle="tab" v-on:click.stop.prevent="switchTab('desktop')" role="tab" aria-controls="nav-home" aria-selected="true">
                                                Asztali verzió
                                            </a>
                                            <a class="nav-item nav-link" :class="{'active': mobile_active}" id="nav-profile-tab"
                                               data-toggle="tab" v-on:click.stop.prevent="switchTab('mobile')" role="tab" aria-controls="nav-profile" aria-selected="false">
                                                Mobil verzió
                                            </a>
                                        </div>
                                    </nav>
                                    <div class="tab-content pt-3 pb-3" id="nav-tabContent">
                                        <div class="tab-pane fade" :class="{'show': desktop_active, 'active': desktop_active }" id="nav-home" role="tabpanel"
                                             aria-labelledby="nav-home-tab">
                                            <div class="row mb-2">
                                                <div class="col-lg-12">
                                                    <label class="control-label">Útvonal</label>
                                                    <label class="inf">(/21754940883/Szekelyfold//SZF_728x190_cikk_)</label>
                                                    <input type="text" class="form-control" v-model="modalData.path"
                                                           :class="{ 'field-error' : this.$v.modalData.path.$error }"/>
                                                </div>
                                            </div>
                                            <div class="row mb-2">
                                                <div class="col-lg-12">
                                                    <label class="control-label">Méretek</label> <label class="inf">([[728, 180], [728, 90], [728, 190]])</label>
                                                    <input type="text" class="form-control" v-model="modalData.size"
                                                           :class="{ 'field-error' : this.$v.modalData.size.$error }"/>
                                                </div>
                                            </div>
                                            <div class="row mb-2">
                                                <div class="col-lg-12">
                                                    <label class="control-label">ID</label> <label class="inf">(div-gpt-ad-1548670151961-0)</label>
                                                    <input type="text" class="form-control" v-model="modalData.div_id"
                                                           :class="{ 'field-error' : this.$v.modalData.div_id.$error }"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade" :class="{'show': mobile_active, 'active': mobile_active }" id="nav-profile" role="tabpanel"
                                             aria-labelledby="nav-profile-tab">
                                            <div class="row mb-2">
                                                <div class="col-lg-12">
                                                    <label class="control-label">Útvonal (mobil)</label>
                                                    <label class="inf">(/21754940883/Szekelyfold//SZF_728x190_cikk_)</label>
                                                    <input type="text" class="form-control" v-model="modalData.path_mobile"/>
                                                </div>
                                            </div>
                                            <div class="row mb-2">
                                                <div class="col-lg-12">
                                                    <label class="control-label">Méretek (mobil)</label> <label class="inf">([[728, 180], [728, 90], [728, 190]])</label>
                                                    <input type="text" class="form-control" v-model="modalData.size_mobile"/>
                                                </div>
                                            </div>
                                            <div class="row mb-2">
                                                <div class="col-lg-12">
                                                    <label class="control-label">ID (mobil)</label> <label class="inf">(div-gpt-ad-1548670151961-0)</label>
                                                    <input type="text" class="form-control" v-model="modalData.div_id_mobile"/>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-2">
                                <div class="col-lg-12">
                                    <label class="control-label">Pozició</label>
                                    <b-form-select v-model="modalData.position" class="form-control" :options="position_list"></b-form-select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer col-lg-12">
                        <div class="form-group row justify-content-center">
                            <div class="col-lg-6">
                                <button class="modal-default-button btn btn-secondary ml-3" @click="close()">Mégsem</button>
                            </div>
                            <div class="col-lg-6">
                                <button class="modal-default-button btn btn-primary ml-3" @click="save()">Kész</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import { required } from 'vuelidate/lib/validators'
    import ImageUploader from "../../common/lib/fileUploader/ImageUploader";

    export default {
        name: 'googleAd-dialog',
        props: {
            show: {
                type: Boolean,
            },
            data: {
                type: Object,
            },
            method: {
                type: Function
            },
        },
        data: function () {
            return {
                position_list: [
                    { value: '', text: 'Inaktív' },
                    { value: 'gtop_90', width:728, height: 90, text: 'Főoldal | fejléc (728x90)' },
                    { value: 'ghome_featured_230h', width:1150, height: 230, text: 'Főoldal | kiemelt (1150x230)' },
                    { value: 'ghome_category1_190', width:728, height: 190, text: 'Főoldal | hirek után (728x190)' },
                    { value: 'ghome_category2_190', width:728, height: 190, text: 'Főoldal | tech után (728x190)' },
                    { value: 'ghome_popular_370', width:370, height: 370, text: 'Főoldal | legnépszerűbb után (370x370)' },

                    { value: 'gtop_90_post', width:728, height: 90, text: 'Cikk | fejléc (728x90)' },
                    { value: 'gright_370', width:370, height: 370, text: 'Cikk | Jobb oldalt (370x370)' },
                    { value: 'gright_600', width:300, height: 600, text: 'Cikk| Jobb oldalt nagy (300x600)' },
                    { value: 'gparagraph_190', width:728, height: 190, text: 'Cikk | Az első bekezdés után (728x190)' },
                    { value: 'gcontent_190', width:728, height: 190, text: 'Cikk | Tartalom után (728x190)' },

                    { value: 'gtop_90_list', width:728, height: 90, text: 'Rovat | fejléc (728x90)' },
                    { value: 'glist_popular_370', width:370, height: 370, text: 'Rovat | legnépszerűbb előtt (370x370)' },
                    { value: 'glist_popular_600', width:370, height: 370, text: 'Rovat | legnépszerűbb után (370x600)' },
                    { value: 'glist_inside_1_190', width:728, height: 190, text: 'Rovat| Cikkek közt 1 (728x190)' },
                    { value: 'glist_inside_2_190', width:728, height: 190, text: 'Rovat| Cikkek közt 2(728x190)' },
                    { value: 'glist_inside_3_190', width:728, height: 190, text: 'Rovat| Cikkek közt 3(728x190)' },
                    { value: 'glist_inside_4_190', width:728, height: 190, text: 'Rovat| Cikkek közt 4(728x190)' },
                ],
                image_removed: false,
                desktop_active: true,
                mobile_active: false,
                modalData: this.data ? this.data : {},
            };
        },
        components: {
            ImageUploader,
        },
        computed: {

        },
        methods: {
            close: function () {
                this.$emit('close');
            },
            save: function () {
                this.$v.modalData.$touch();

                if(this.modalData.name && this.modalData.path && this.modalData.size && this.modalData.div_id) {

                    if(this.modalData.position) {
                        let item = this.position_list.find(p => p.value == this.modalData.position);
                        this.modalData.width = item.width;
                        this.modalData.height = item.height;
                    }

                    this.$emit('onProcessed', this.modalData);
                    this.close();
                } else {
                    this.$emit('onProcessError', this.modalData);
                    this.$store.commit('setErrorMessage', 'Töltse ki a mezőket!');
                }
            },
            switchTab(type) {
                if(type === 'desktop') {
                    this.desktop_active = true;
                    this.mobile_active = false;
                } else {
                    this.desktop_active = false;
                    this.mobile_active = true;
                }
            },
            getDesktopCode() {
                this.modalData.path_mobile = this.modalData.path;
                this.modalData.size_mobile = this.modalData.size;
                this.modalData.div_id_mobile = this.modalData.div_id;
            },
            resetMobileForm() {
                this.modalData.path_mobile = '';
                this.modalData.size_mobile = '';
                this.modalData.div_id_mobile = '';
            }
        },
        mounted: function () {
            document.addEventListener("keydown", (e) => {
                if (this.show && e.keyCode == 27) {
                    this.close();
                }
            });
        },
        watch: {
            data: {
                handler: function(newVal) {
                    this.modalData = newVal;
                },
                deep: true,
            },
        },
        validations() {
            return {
                modalData: {
                    name: required,
                    path: required,
                    size: required,
                    div_id: required,
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    * {
        box-sizing: border-box;
    }

    .inf {
        font-size: 12p;
        color: red;
    }

    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        transition: opacity .3s ease;
    }

    .modal-container {
        width: 450px;
        margin: 40px auto 0;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 0px 0;
    }

    .text-right {
        text-align: right;
    }

    .form-label {
        display: block;
        margin-bottom: 1em;
    }

    .form-label > .form-control {
        margin-top: 0.5em;
    }

    .form-control {
        display: block;
        width: 100%;
        padding: 0.5em 1em;
        line-height: 1.5;
        border: 1px solid #ddd;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    .hr {
        border-bottom: 1px #ededed solid;
    }

    .del {
        padding-top: 27px;
        font-size: 20px;
        cursor: pointer;
    }

    .items-holder {
        height: 250px;
        overflow-y: auto;
        overflow-x: hidden;
    }
</style>